import { createContext } from "react";
import type { RoleTerms } from "../constants/platformTerms";

export interface OpenPlatformTermsOptions {
  terms: RoleTerms;
  version?: string;
  accent?: "violet" | "blue";
  onReviewed?: () => void;
}

export interface TermsModalContextValue {
  open: (options: OpenPlatformTermsOptions) => void;
  close: () => void;
}

export const TermsModalContext = createContext<TermsModalContextValue | null>(null);
